module.exports = __webpack_public_path__ + "static/media/icon-confetti.185f93d3.svg";